import * as React from "react";
import { useLogin } from "@refinedev/core";

export function LoginPage(): React.JSX.Element {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState<string | null>(null);

  const { mutate: login, isPending: isLoading } = useLogin<{ email: string; password: string }>();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    setError(null);

    login(
      { email, password },
      {
        onError: (err: unknown) => {
          const message =
            err instanceof Error
              ? err.message
              : (err as { message?: string })?.message ?? "Неверный email или пароль";
          setError(message);
        },
      }
    );
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-[var(--bg)]">
      <div className="bg-[var(--surface)] border border-[var(--border)] rounded-[var(--radius)] p-8 w-full max-w-[400px]">
        <h1 className="text-[22px] font-[700] mb-2 text-[var(--fg)]">Jourio Admin</h1>
        <p className="text-[var(--muted)] text-[13px] mb-6">Введите данные для входа</p>

        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-4">
            <label
              htmlFor="admin-email"
              className="block text-[13px] font-[500] text-[var(--fg)] mb-1.5"
            >
              Email
            </label>
            <input
              id="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="operator@jourio.com"
              required
              autoComplete="email"
              className="w-full px-3 py-2 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--bg)] text-[var(--fg)] text-[14px] placeholder:text-[var(--muted)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:border-[var(--accent)] min-h-[44px]"
            />
          </div>

          <div className="mb-6">
            <label
              htmlFor="admin-password"
              className="block text-[13px] font-[500] text-[var(--fg)] mb-1.5"
            >
              Пароль
            </label>
            <input
              id="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
              className="w-full px-3 py-2 rounded-[var(--radius)] border border-[var(--border)] bg-[var(--bg)] text-[var(--fg)] text-[14px] placeholder:text-[var(--muted)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:border-[var(--accent)] min-h-[44px]"
            />
          </div>

          {error && (
            <div
              role="alert"
              className="mb-4 px-3 py-2 rounded-[var(--radius)] border border-[var(--danger)] bg-[color-mix(in_srgb,var(--danger)_8%,transparent)] text-[var(--danger)] text-[13px]"
            >
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[var(--accent)] text-white font-[600] text-[14px] rounded-[var(--radius)] py-2.5 px-4 min-h-[44px] hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-opacity"
          >
            {isLoading ? "Входим..." : "Войти"}
          </button>
        </form>
      </div>
    </div>
  );
}
